export default __webpack_public_path__ + "static/19209-533578912b662c1f2bf242a0354a0199.jpg";